// prettier-ignore
const colorCodes = [
  '#FEF', '#F9A', '#E59', '#F6A', '#F06', '#B47', '#C05', '#903', '#523',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#FBC', '#F77', '#D31', '#F54', '#F00', '#C66', '#B44', '#B00', '#822',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#EEE', '#DCB', '#FC6', '#D62', '#FA2', '#F60', '#B85', '#D40', '#B40', '#631',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#DDD', '#FED', '#FDC', '#FCA', '#FB8', '#FA8', '#D86', '#B64', '#953', '#842',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#CCC', '#FCF', '#E8F', '#C6D', '#B8C', '#C0F', '#969', '#80A', '#507', '#304',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#BBB', '#FBF', '#F9F', '#D2B', '#F5E', '#F0C', '#857', '#B09', '#806', '#504',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#AAA', '#DB9', '#CA7', '#743', '#A74', '#930', '#732', '#520', '#310', '#210',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#999',
  '#FFC', '#FF7', '#DD2', '#FF0', '#FD0', '#CA0', '#990', '#870', '#550',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#888', '#DBF', '#B9E', '#63C', '#95F', '#60F', '#548', '#409', '#206', '#213',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#777', '#BBF', '#89F', '#33A', '#35E', '#00F', '#338', '#00A', '#116', '#002',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#666', '#9EB', '#6C7', '#261', '#4A3', '#083', '#575', '#250', '#132', '#021',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#555', '#DFB', '#CF8', '#8A5', '#AD8', '#8F0', '#AB9', '#6B0', '#590', '#360',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#444', '#BDF', '#7CF', '#359', '#69F', '#17F', '#47A', '#247', '#027', '#014',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#333', '#AFF', '#5FF', '#08B', '#5BC', '#0CF', '#49A', '#068', '#045', '#023',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#222', '#CFE', '#AED', '#3CA', '#5EB', '#0FC', '#7AA', '#0A9', '#087', '#043',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',
  '#000', '#AFA', '#7F7', '#6D4', '#0F0', '#2D2', '#5B5', '#0B0', '#080', '#242',
  '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF',];

export function renderNormalToCanvas(
  ctx: CanvasRenderingContext2D,
  paletteColors: Uint8Array,
  colorData: Uint8Array,
  canvasSize = 192
): void {
  const squareSize = canvasSize / 32;

  if (!colorData || !paletteColors) {
    throw Error('missing colorData or paletteColors');
  }

  const squareData = new Uint8Array(32 * 32);
  colorData.forEach((byte, i) => {
    squareData[i * 2] = byte & 0xf;
    squareData[i * 2 + 1] = (byte >> 4) & 0xf;
  });

  for (let y = 0; y < 32; y += 1) {
    for (let x = 0; x < 32; x += 1) {
      const colorCodeIdx = paletteColors[squareData[y * 32 + x]];
      ctx.fillStyle = colorCodes[colorCodeIdx];
      const px = Math.round(x * squareSize - 0.5);
      const py = Math.round(y * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }
}

export function renderProToCanvas(
  ctx: CanvasRenderingContext2D,
  paletteColors: Uint8Array,
  colorData: Uint8Array[],
  usage: number,
  canvasSize = 192
): void {
  if (colorData.length !== 4) {
    throw Error('4 QR data required for rendering PRO');
  }

  const squareData = createSquareColorData(
    colorData as [Uint8Array, Uint8Array, Uint8Array, Uint8Array]
  );
  const squareSize = canvasSize / 64;

  if (usage === 8) {
    renderKaohameToCanvas(ctx, paletteColors, squareData, squareSize);
    return;
  }

  // back
  for (let y = 0; y < 48; y += 1) {
    for (let x = 0; x < 32; x += 1) {
      if (checkIfMaskedFrontBack(usage, x, y)) {
        continue;
      }
      let index: number;
      if (y < 32) {
        index = (y + 32) * 32 + x;
      } else {
        index = (y - 32 + 112) * 32 + x;
      }
      const paletteIndex = squareData[index];
      const colorCodeIdx = paletteColors[paletteIndex];
      ctx.fillStyle = colorCodes[colorCodeIdx];
      const px = Math.round(x * squareSize - 0.5);
      const py = Math.round(y * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }

  // front
  for (let y = 0; y < 48; y += 1) {
    for (let x = 0; x < 32; x += 1) {
      if (checkIfMaskedFrontBack(usage, x, y)) {
        continue;
      }
      let index: number;
      if (y < 32) {
        index = y * 32 + x;
      } else {
        index = (y - 32 + 96) * 32 + x;
      }
      const paletteIndex = squareData[index];
      const colorCodeIdx = paletteColors[paletteIndex];
      ctx.fillStyle = colorCodes[colorCodeIdx];
      const px = Math.round((x + 32) * squareSize - 0.5);
      const py = Math.round(y * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }

  // right
  for (let y = 0; y < 16; y += 1) {
    for (let x = 0; x < 32; x += 1) {
      if (checkIfMaskedRightLeft(usage, x, y)) {
        continue;
      }
      const index = (y + 64) * 32 + x;
      const paletteIndex = squareData[index];
      const colorCodeIdx = paletteColors[paletteIndex];
      ctx.fillStyle = colorCodes[colorCodeIdx];
      const px = Math.round(x * squareSize - 0.5);
      const py = Math.round((y + 48) * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }

  // left
  for (let y = 0; y < 16; y += 1) {
    for (let x = 0; x < 32; x += 1) {
      if (checkIfMaskedRightLeft(usage, x, y)) {
        continue;
      }
      const index = (y + 80) * 32 + x;
      const paletteIndex = squareData[index];
      const colorCodeIdx = paletteColors[paletteIndex];
      ctx.fillStyle = colorCodes[colorCodeIdx];
      const px = Math.round((x + 32) * squareSize - 0.5);
      const py = Math.round((y + 48) * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }
}

function renderKaohameToCanvas(
  ctx: CanvasRenderingContext2D,
  paletteColors: Uint8Array,
  squareData: Uint8Array,
  squareSize: number
) {
  const xOffset = 6;

  // Upper
  for (let y = 0; y < 64; y += 1) {
    for (let x = 0; x < 32; x += 1) {
      const sx = x + xOffset;
      const sy = y;
      if (checkIfMaskedKaohame(sx, sy)) {
        continue;
      }
      const index = y * 32 + x;
      const paletteIndex = squareData[index];
      const colorCodeIdx = paletteColors[paletteIndex];
      ctx.fillStyle = colorCodes[colorCodeIdx];
      const px = Math.round(sx * squareSize - 0.5);
      const py = Math.round(sy * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }

  // Lower
  for (let y = 0; y < 64; y += 1) {
    for (let x = 0; x < 32 - 12; x += 1) {
      const sx = x + xOffset + 32;
      const sy = y;

      if (checkIfMaskedKaohame(sx, sy)) {
        continue;
      }
      const index = (y + 64) * 32 + x;
      const paletteIndex = squareData[index];
      const colorCodeIdx = paletteColors[paletteIndex];
      ctx.fillStyle = colorCodes[colorCodeIdx];

      const px = Math.round(sx * squareSize - 0.5);
      const py = Math.round(sy * squareSize - 0.5);
      const size = Math.round(squareSize + 0.5);
      ctx.fillRect(px, py, size, size);
    }
  }
}

function concatenate(...arrays: Uint8Array[]) {
  let totalLength = 0;
  for (const arr of arrays) {
    totalLength += arr.length;
  }
  const result = new Uint8Array(totalLength);
  let offset = 0;
  for (const arr of arrays) {
    result.set(arr, offset);
    offset += arr.length;
  }
  return result;
}

function createSquareColorData(
  colorData: [Uint8Array, Uint8Array, Uint8Array, Uint8Array]
): Uint8Array {
  const [d0, d1, d2, d3] = colorData;
  const concatenated = concatenate(d0, d1, d2, d3);
  const squareData = new Uint8Array(4096);
  concatenated.forEach((byte, i) => {
    squareData[i * 2] = byte & 0xf;
    squareData[i * 2 + 1] = (byte >> 4) & 0xf;
  });
  return squareData;
}

function checkIfMaskedFrontBack(usage: number, _: number, y: number) {
  switch (usage) {
    case 3:
    case 4:
    case 5:
      return y >= 32;
    default:
      return false;
  }
}

function checkIfMaskedRightLeft(usage: number, x: number, _: number) {
  switch (usage) {
    case 1:
    case 4:
      return x >= 16;
    case 2:
    case 5:
      return true;
    default:
      return false;
  }
}

function checkIfMaskedKaohame(x: number, y: number) {
  // 左上
  if (y === 0 && x >= 6 && x < 10) {
    return true;
  }
  if (y === 1 && x >= 6 && x < 8) {
    return true;
  }
  if (y === 2 && x >= 6 && x < 7) {
    return true;
  }

  // 右上
  if (y === 0 && x >= 54) {
    return true;
  }
  if (y === 1 && x >= 56) {
    return true;
  }
  if (y === 2 && x >= 57) {
    return true;
  }

  if (y < 13 || y >= 32) {
    return false;
  }
  switch (y) {
    case 13:
      return x >= 32 - 4 && x < 32 + 4;
    case 14:
      return x >= 32 - 7 && x < 32 + 7;
    case 15:
      return x >= 32 - 9 && x < 32 + 9;
    case 16:
      return x >= 32 - 10 && x < 32 + 10;
    case 17:
      return x >= 32 - 11 && x < 32 + 11;
    case 18:
    case 19:
      return x >= 32 - 12 && x < 32 + 12;
    case 20:
    case 21:
    case 22:
    case 23:
    case 24:
      return x >= 32 - 13 && x < 32 + 13;
    case 25:
      return x >= 32 - 12 && x < 32 + 12;
    case 26:
      return x >= 32 - 12 && x < 32 + 11;
    case 27:
      return x >= 32 - 11 && x < 32 + 11;
    case 28:
      return x >= 32 - 10 && x < 32 + 10;
    case 29:
      return x >= 32 - 8 && x < 32 + 8;
    case 30:
      return x >= 32 - 6 && x < 32 + 6;
    case 31:
      return x >= 32 - 3 && x < 32 + 3;
    default:
      return false;
  }
}
